var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-picker',{attrs:{"show-toolbar":"","columns":_vm.columns},on:{"confirm":_vm.onConfirm,"cancel":_vm.cancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }